module.exports = __webpack_public_path__ + "static/img/header_logo.b64bd65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header_logo.svg
// module id = gsDv
// module chunks = 1